import { FormattedMessage } from 'react-intl'
import React from 'react'
import { css, cx } from '@emotion/css'
import { theme as deprecatedTheme } from '../../../../styled'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { LoadingMaskRectangle } from '../../../../legacy-design-system/loading-masks'

const cssTitle = css`
  font-size: 20px;
  font-family: ${deprecatedTheme.fontFamilies.primary};
  color: ${theme.color.neutral100};
  font-weight: bold;
`

const TitleWrapper = ({ children }) => (
  <div
    className={cx(
      cssTitle,
      css`
        margin-bottom: 12px;
      `
    )}
  >
    {children}
  </div>
)

const InfoWrapper = ({ children }) => (
  <div
    className={css`
      color: ${theme.color.neutral60};
      margin-bottom: 16px;
    `}
  >
    {children}
  </div>
)

export function VrModuleTitle({ id }: { readonly id: string }) {
  return (
    <FormattedMessage id={id}>
      {(msg) => <TitleWrapper>{msg}</TitleWrapper>}
    </FormattedMessage>
  )
}

export function VrModuleInfo({ id }: { readonly id: string }) {
  return (
    <FormattedMessage id={id}>
      {(msg) => <InfoWrapper>{msg}</InfoWrapper>}
    </FormattedMessage>
  )
}

export function VrModuleTitleLoadingView() {
  return (
    <TitleWrapper>
      <LoadingMaskRectangle width={300} height={28} />
    </TitleWrapper>
  )
}
